// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~css/colors.css'","_gray-darker":"#333333","root":"NoLiveBulletin_root__1aF2F","header":"NoLiveBulletin_header__YLQvg","description":"NoLiveBulletin_description__3sDoR"};